export const fileAttachmentConsts = {
    FILETYPES_SUPPORTED: [
        '.mp3',
        '.mp4',
        '.csv',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.pdf',
        '.pps',
        '.ppsx',
        '.ppt',
        '.pptx',
        '.rtf',
        '.txt',
        '.vsd',
        '.wbp',
        '.xps',
        '.txt',
        '.xlt',
        '.bmp',
        '.gif',
        '.jpeg',
        '.jpg',
        '.png',
    ],
    FILE_NOT_SUPPORTED: 'File type not supported',
    MAX_FILE_COUNT_EXCEEDED: 'Max file count limit exceeded',
    FILENAME_ALREADY_EXISTS: 'File name already exists',
    DELETE_CONFIRMATION: 'Are you sure you want to delete the item?',
    FILE_SIZE_EXCEEDED: 'File Size Exceeded. Max File Size is 25 MB',
    FILE_SIZE_EXCEEDED_DRAG_DROP: 'File Size Exceeded. Max File Size is 100 MB',
    ERROR_MESSAGE_TIMEOUT_SECONDS: '3000',
    MAX_FILE_SIZE: '100',
    ATTACHMENTS: 'Attachments',
    ATTACH_FILE: 'Attach file',
    WAIVER_ATTACH_FILE: 'Attach supporting documents for the Waiver',
    ATTACH_REQ: 'Attachment is required for Title Waivers',
    MAX_FILENAME_COUNT_EXCEEDED: 'Please ensure the filename length with extension is not more than 100 characters.',
};
